import { css } from 'styled-components';

const OrdersOverviewNewStyle = css`
  display: flex;
  flex-direction: column;
  width: 100%;
  @media ${(props) => props.theme.mediaQuery.smallOnly} {
    &.no-orders-available {
      padding-right: ${(props) => props.theme.spacing.ELEM_SPACING.SM};
      width: calc(100% - ${(props) => props.theme.spacing.ELEM_SPACING.SM});
    }
  }
  @media ${(props) => props.theme.mediaQuery.mediumOnly} {
    &.no-orders-available {
      padding-right: 33px;
      width: calc(100% - 33px);
    }
  }
  .orders-tile-heading-text {
    margin-left: ${(props) => props.theme.spacing.ELEM_SPACING.MED};
    font-family: ${(props) => props.theme.typography.fonts.secondary};
    font-weight: ${(props) => props.theme.fonts.fontWeight.bold};
    font-size: ${(props) => props.theme.typography.fontSizes.fs20};
    text-transform: uppercase;
    color: ${(props) => props.theme.colorPalette.gray[900]};
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      font-weight: 700;
      font-size: ${(props) => props.theme.typography.fontSizes.fs16};
    }
  }
  .orders-tile-heading {
    align-items: center;
    display: flex;
    .orders-tile-heading-left {
      display: flex;
      align-items: center;
    }
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      justify-content: space-between;
    }
  }

  .orders-tile-main {
    padding-top: ${(props) => props.theme.spacing.ELEM_SPACING.MED};
  }

  .orders-tile-view-all {
    text-decoration: underline;
    margin-left: ${(props) => props.theme.spacing.ELEM_SPACING.MED};
    font-family: ${(props) => props.theme.typography.fonts.secondary};
    font-size: ${(props) => props.theme.typography.fontSizes.fs16};
    line-height: 22px;
    color: #1a1a1a;
    margin-right: 19px;
  }
  .orders-icon {
    width: 22px;
    height: 22px;
    margin-left: 6px;
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      width: 20px;
      height: 20px;
    }
  }
`;
export default OrdersOverviewNewStyle;
